import React, { Component, Fragment } from 'react';
import withSizes from 'react-sizes';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Cookie from 'js-cookie';
import StarRatings from 'react-star-ratings';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectDate, selectGuests, selectProduct, updateProduct, updateProductPrice, openModal, onFreePassClick, checkinDateProcessDefault, resetCheckout } from '../../redux/actions';
import { Router } from '../../routes';
import { Button, WhyCharged } from '../../components';
import { Gold, Triangle, Calendar, Shield, Bell, getProductTypeName, slugify, axiosInstance, objectIsEmpty } from '../../utils';
import { AmountCounter, DatePicker, DropdownContainer, PromoBox, SelectorModalMobile } from '../index';

import {
  HotelPanelArticle,
  HotelPanelStatsContainer,
  HotelPanelPrice,
  HotelCrossedPrice,
  HotelPanelOldPrice,
  HotelPanelStats,
  HotelPanelVotes,
  HotelPanelBook,
  HotelPanelNote,
  HotelPanelTotalTable,
  HotelPanelDescription,
  HotelPanelFooter,
  HotelPanelFeatures,
  HotelPanelFeatureWrapper,
  HotelPanelFeature,
  SignUpButton,
  HotelPanelWays,
  HotelPanelWarning,
  HotelInfo,
  HotelInfoContainer,
  HotelFeaturesList,
  HotelPhoto,
  ProductName,
  DatePickerWaitlist,
  ServiceFeeToolTip,
  QuestionTooltipBlock,
} from './styles';

const mapStateToProps = state => ({
  userProduct: state.userProduct,
  userPreferences: state.userPreferences,
  userData: state.user.userData,
  promo: state.promo,
  checkoutError: state.payment.membershipError,
  checkoutStatus: state.payment.status,
  bookingManagement: state.bookingManagement,
  changeCheckinDateData: state.bookingManagement.changeCheckingDate,
  usingCredits: state.payment.usingCredits,
  membershipError: state.payment.membershipError,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleWaySelect: selectProduct,
  handleDateSelect: selectDate,
  handleGuestSelect: selectGuests,
  handleDateChange: updateProductPrice,
  handleProductChange: updateProduct,
  handleModalOpenClick: openModal,
  handleFreePass: onFreePassClick,
  changingDateDefault: checkinDateProcessDefault,
  resetPaymentData: resetCheckout,
}, dispatch);

const mapSizesToProps = ({ width }) => ({
  isTablet: width >= 768,
  isMobile: width < 768,
});

@withSizes(mapSizesToProps)
@connect(mapStateToProps, mapDispatchToProps)
class HotelPanel extends Component {
  static propTypes = {
    products: PropTypes.instanceOf(Array),
    userPreferences: PropTypes.instanceOf(Object),
    userProduct: PropTypes.instanceOf(Object),
    handleProductChange: PropTypes.func,
    handleDateSelect: PropTypes.func,
    handleGuestSelect: PropTypes.func,
    handleDateChange: PropTypes.func,
    handleModalOpenClick: PropTypes.func,
    isTablet: PropTypes.bool,
    isMobile: PropTypes.bool,
    rating: PropTypes.number,
    totalReviews: PropTypes.number,
    counter: PropTypes.number,
    isComingSoon: PropTypes.bool,
    checkoutPage: PropTypes.bool,
    promo: PropTypes.instanceOf(Object),
    userData: PropTypes.instanceOf(Object),
    bookingManagement: PropTypes.instanceOf(Object),
    handleFreePass: PropTypes.func,
    checkoutStatus: PropTypes.string,
    changeCheckinDateData: PropTypes.instanceOf(Object),
    changingDateDefault: PropTypes.func,
    membershipError: PropTypes.string,
    resetPaymentData: PropTypes.func,
    usingCredits: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentDropdown: null,
      calendarData: {
        capacity: [],
        capacityByDay: {},
        unavailableDates: [],
      },
      loadingPrice: true,
      loading: false,
      showWarning: false,
    };
  }

  async componentDidMount() {
    const { setUpProduct, setUpPossibleDate } = this;
    const { changeCheckinDateData: { isPaying }, changingDateDefault, resetPaymentData, checkoutPage } = this.props;
    setUpPossibleDate();
    if (!checkoutPage) {
      resetPaymentData();
    }
    const productData = await setUpProduct();
    Router.events.on('routeChangeStart', () => { if (isPaying) {
      changingDateDefault();
    }});

    this.setState({
      ...productData,
    });

  }

  async componentDidUpdate(prevProps) {
    const { setUpProduct, setUpPossibleDate } = this;
    const { loadingPrice, calendarData: { unavailableDates, capacityByDay } } = this.state;
    const { userProduct: oldProduct, checkoutStatus: oldCheckoutStatus } = prevProps;
    const { userPreferences, handleGuestSelect, userProduct: newProduct, checkoutStatus: newCheckoutStatus, resetPaymentData } = this.props;
    const { guests, date } = userPreferences;

    if (oldCheckoutStatus !== newCheckoutStatus && newCheckoutStatus === 'failure') {
      this.setState({
        ...await setUpProduct(),
      });
    }

    if (!newProduct.product.price.isFetching && loadingPrice) {
      this.setState({
        loadingPrice: false,
      })
    }

    if (oldProduct.product.id !== newProduct.product.id) {
      resetPaymentData();
      this.setState({
        ...await setUpProduct(),
      });
    }

    const placesLeft = this.getPlacesLeftToday() <= 0 ? 1 : this.getPlacesLeftToday();

    if (guests > placesLeft) {
      handleGuestSelect(placesLeft);
    }

    const formattedDate = moment(date).format('YYYY-MM-DD');

    if ((unavailableDates.includes(formattedDate) || capacityByDay[moment(formattedDate).day()] === 0) && Object.values(capacityByDay).filter(e => e !== 0).length){
      setUpPossibleDate();
    }
  };

  setUpPossibleDate = () => {
    const { userPreferences, handleDateSelect, handleDateChange } = this.props;
    const { calendarData: { unavailableDates, capacityByDay } } = this.state;

    const { date } = userPreferences;

    const formattedDate = moment(date).format('YYYY-MM-DD');

    let newPossibleDate = formattedDate;

    if (Object.keys(capacityByDay).filter(day => capacityByDay[day] !== 0).length !== 0 && (unavailableDates.includes(formattedDate) || capacityByDay[moment(formattedDate).day()] === 0)) {
      while (unavailableDates.includes(newPossibleDate) || capacityByDay[moment(newPossibleDate).day()] === 0) {
        newPossibleDate = moment(newPossibleDate)
          .add(1, 'day')
          .format('YYYY-MM-DD');
      }

      handleDateSelect(newPossibleDate);
      handleDateChange(newPossibleDate);
    }
    handleDateChange(newPossibleDate);
  };

  setDefaultDate = () => {
    const { setUpPossibleDate, handleDropdownToggle, } = this;
    const { handleDateSelect } = this.props;
    const today = moment().format('YYYY-MM-DD');
    handleDateSelect(today);
    setUpPossibleDate();
    handleDropdownToggle('date');
  };

  setUpProduct = async () => {
    this.setState({
      loadingPrice: true,
    });

    const { userProduct } = this.props;
    const { product: { id } } = userProduct;
    const { data: calendar } = await axiosInstance.get(`products/tickets/${id}`);

    const unavailableDates = calendar.capacity
      .filter(disabledDate => disabledDate.tickets === 0)
      .reduce((acc, curr) => [...acc, curr.date], []);

    const availableDates = calendar.capacity
      .filter(dateInfo => dateInfo.tickets !== 0)
      .reduce((acc, curr) => ({
        ...acc,
        [curr.date]: curr.tickets,
      }), {});

    return {
      calendarData: {
        ...calendar,
        capacity: availableDates,
        unavailableDates: [...new Set(unavailableDates)],
      },
    };
  };

  handleDropdownToggle = name => {
    const { currentDropdown } = this.state;

    this.setState({
      currentDropdown: currentDropdown !== name ? name : null,
    });
  };

  handleProductClick = name => {
    const { handleProductChange } = this.props;

    this.handleDropdownToggle('way');
    handleProductChange(name);
    this.setState({
      loading: false,
    });
  };

  getProductAmount = () => {
    const { userProduct, userPreferences } = this.props;
    const { product } = userProduct;
    const { guests } = userPreferences;
    const { maxGuests } = product;

    if (maxGuests === 1) {
      return guests / maxGuests;
    }

    return Math.ceil(guests / maxGuests);
  };

  getPriceTag = () => {
    const { loadingPrice } = this.state;
    const { userProduct } = this.props;
    const { product } = userProduct;
    const { price } = product;
    const { newPrice, oldPrice } = price;

    let content;

    if (newPrice < oldPrice) {
      content = (
        <HotelPanelPrice blured={loadingPrice}>
          <HotelCrossedPrice>${oldPrice}</HotelCrossedPrice>
          <HotelPanelOldPrice>
            <span>${newPrice || '00.00'}</span>
            /guest
          </HotelPanelOldPrice>
        </HotelPanelPrice>
      );
    } else {
      content = (
        <HotelPanelPrice blured={loadingPrice}>
          ${newPrice || '00.00'}
          <span>/guest</span>
        </HotelPanelPrice>
      );
    }

    return content;
  };

  getPlacesLeftToday = () => {
    const { calendarData } = this.state;
    const { userProduct, userPreferences } = this.props;
    const { product } = userProduct;
    const { date } = userPreferences;
    const { maxGuests } = product;
    const { capacity, capacityByDay } = calendarData;

    const currDateCap = capacity[date];
    const tickets = currDateCap || capacityByDay[moment(date).day()];
    return tickets * maxGuests;
  };

  getWarningTag = () => {
    const { userProduct, userPreferences } = this.props;
    const { showWarning } = this.state;
    const { product } = userProduct;
    const { guests } = userPreferences;
    const { maxGuests, type } = product;
    const placesLeftToday = this.getPlacesLeftToday();
    const leftAmount = placesLeftToday / maxGuests;

    let warning;

    if (placesLeftToday === 0) {
      warning = (
        <HotelPanelWarning>
          Sorry there are no places left at this hotel at selected day
        </HotelPanelWarning>
      );
    } else if (placesLeftToday <= guests && showWarning) {
      warning = (
        <HotelPanelWarning>
          {`Sorry only ${leftAmount} ${getProductTypeName(type, leftAmount)} ${leftAmount > 1 ? 'are' : 'is'} left at this hotel which accommodates max ${maxGuests} people`}
        </HotelPanelWarning>
      );
    }

    return warning;
  };

  handleBookClick = () => {
    const { userData, userProduct, userPreferences, handleFreePass } = this.props;
    const { hotel, product } = userProduct;
    const {
      guests,
      date,
    } = userPreferences;

    const {
      name,
      id,
      type,
    } = product;

    const {
      name: hotelName,
      market,
    } = hotel;

    this.setState({
      loading: true,
    });

    if (userData && !objectIsEmpty(userData.subscription) && !userData.last24freeDayPass && Number(type) === 0 && Number(guests) === 1 && moment(date).isBefore(moment().add(1, 'day'))) {
      handleFreePass();
      this.setState({
        loading: false,
      });
    } else {
      localStorage.setItem('userSession', JSON.stringify({
        ...userProduct,
        sessionExp: new Date(Date.now() + (5 * 60 * 1000)),
      }));

      Cookie.set('userSession', JSON.stringify({productName: userProduct.product.name, hotelName: userProduct.hotel.name}), { path: '/' });

      Router.pushRoute(
        'checkout-hotel',
        {
          marketName: slugify(market),
          hotelName: slugify(hotelName),
          productName: slugify(name),
          productId: id
        }
      );
    }
  };

  handleOpenSignUpButtonClick = () => {
    const { handleModalOpenClick } = this.props;
    const { handleDropdownToggle } = this;

    handleDropdownToggle('date');
    handleModalOpenClick('signUpForEmailAlert');
  };

  handleDayClick = day => {
    const { handleDateSelect } = this.props;

    handleDateSelect(day);

    this.setState({
      currentDropdown: null,
    })
  };

  calculateTotalWithPromo = (hasSub = false) => {
    const { userProduct: { product }, promo } = this.props;
    const { price } = product;
    const { total } = price;
    const productAmount = this.getProductAmount();
    const amountToSubtract = hasSub ? 1 : 0;
    const {
      info: {
        type: promoType,
        amount: promoAmount,
      }
    } = promo;

    const initialPrice = (productAmount - amountToSubtract) * total;

    switch (Number(promoType)) {
      case 0:
        return (initialPrice * ((100 - promoAmount) / 100)).toFixed(2);
      case 1:
        return initialPrice - promoAmount >= 0 ? (initialPrice - promoAmount).toFixed(2) : 0;
      default:
        return initialPrice.toFixed(2);
    }
  };

  getPromoValue = (hasSub = false) => {
    const { calculateTotalWithPromo } = this;
    const { promo, userProduct: { product } } = this.props;
    const { price } = product;
    const { total } = price;
    const productAmount = this.getProductAmount();
    const amountToSubtract = hasSub ? 1 : 0;
    const initialPrice = (productAmount - amountToSubtract) * total;

    const {
      info: {
        type: promoType,
        amount: promoAmount,
      }
    } = promo;

    switch (Number(promoType)) {
      case 0:
        return `$${(initialPrice - calculateTotalWithPromo(hasSub)).toFixed(2)}`;
      case 1:
        return `$${promoAmount}`;
      default:
        return `$${promoAmount}`;
    }
  };

  setWarning = showWarning => {
    this.setState({
      showWarning,
    })
  };

  handleDayChange = (date, initial = false) => {
    const { handleDateChange } = this.props;
    handleDateChange(date);

    if (initial) {
      handleDateChange();
    }

    this.setState({
      currentDropdown: null,
    });
  };

  render() {
    const {
      getPriceTag,
      getWarningTag,
      handleProductClick,
      getProductAmount,
      handleBookClick, handleDayClick,
      getPromoValue,
      calculateTotalWithPromo,
      handleOpenSignUpButtonClick,
      setWarning,
      setDefaultDate,
      handleDropdownToggle,
     } = this;

    const { currentDropdown, loading, calendarData, loadingPrice } = this.state;
    const {
      isTablet,
      isMobile,
      userPreferences,
      handleGuestSelect,
      handleDateChange,
      products,
      rating,
      totalReviews,
      checkoutPage,
      counter,
      userProduct,
      isComingSoon,
      isPreview,
      promo,
      userData,
      changeCheckinDateData,
      usingCredits,
      bookingManagement,
      membershipError
    } = this.props;

    const { diff, tax: changingTax, isPaying: checkInDatePayment } = changeCheckinDateData;
    const { product, hotel } = userProduct;

    const { name: hotelName, city } = hotel;
    const { name, maxGuests, price, type, image } = product;
    const { discountName, tax, rate, total, oldTotal, newPrice, isErrored, serviceFee : serviceFee2  } = price;
    const { guests, date } = userPreferences;
    const placesLeftToday = this.getPlacesLeftToday();
    const disabledInc = placesLeftToday <= guests || placesLeftToday === 0;
    const disabledBtn = placesLeftToday < guests || placesLeftToday === 0;
    const productAmount = getProductAmount();
    const productTypeName = getProductTypeName(type, productAmount);
    let userCredits;
    let changingNewDate;
    let changingProductName;
    let neighborhood;
    let changingHotelName;
    let changingHotelPicture;

    if(checkInDatePayment) {
      const { changeCheckingDate : { newDate: changingNewDateD }, hotel: { productName: changingProductNameD, neighborhood: neighborhoodD, hotelName: hotelNameD, hotelPicture: hotelPictureD } } = bookingManagement;
      changingNewDate = changingNewDateD;
      changingProductName = changingProductNameD;
      neighborhood = neighborhoodD;
      changingHotelName = hotelNameD;
      changingHotelPicture = hotelPictureD;
    }
    const neededDate = checkInDatePayment ? changingNewDate : date;
    const neededProductName = checkInDatePayment ? changingProductName : product.name;
    const neededMarketName = checkInDatePayment ? neighborhood : city;
    const neededHotelName = checkInDatePayment ? changingHotelName : hotelName;
    const neededHotelPicture = checkInDatePayment ? changingHotelPicture : image;


    if (userData) {
      userCredits = userData.credits.total;
    };
    
    const serviceFee = (serviceFee2 || 0);
    const productAmountWithSubscription = userData && !objectIsEmpty(userData.subscription) && !userData.last24freeDayPass && moment(userPreferences.date).isBefore(moment().add(1, 'day')) ? productAmount - 1 : productAmount;

    return (
      <HotelPanelArticle>
        {checkoutPage && (
          <HotelInfo>
            <HotelPhoto>
              <img src={`${process.env.CDN_URL}${neededHotelPicture}`} alt={neededHotelName} />
            </HotelPhoto>
            <HotelInfoContainer>
              <HotelFeaturesList>
                <li>{neededProductName}</li>
                <li>{neededMarketName}</li>
              </HotelFeaturesList>
              <ProductName>{neededHotelName}</ProductName>
              <HotelPanelStats itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
                <HotelPanelVotes itemProp="reviewCount" content={totalReviews === 0 ? '' : totalReviews}>{totalReviews === 0 ? '' : totalReviews}</HotelPanelVotes>
                <span itemProp="ratingValue" content={rating === 0 ? 5 : rating}>
                  <StarRatings
                    rating={rating === 0 ? 5 : rating}
                    numberOfStars={5}
                    starRatedColor="#1eb6ff"
                    starEmptyColor="#b6e4f9"
                    starDimension="15px"
                    starSpacing="0px"
                  />
                </span>
              </HotelPanelStats>
            </HotelInfoContainer>
          </HotelInfo>
        )}
        {!checkoutPage && (
          <HotelPanelStatsContainer>
            {getPriceTag()}
            <HotelPanelStats>
              <HotelPanelVotes>{totalReviews === 0 ? '' : totalReviews}</HotelPanelVotes>
              <StarRatings
                rating={rating === 0 ? 5 : rating}
                numberOfStars={5}
                starRatedColor="#1eb6ff"
                starEmptyColor="#b6e4f9"
                starDimension="15px"
                starSpacing="0px"
              />
            </HotelPanelStats>
          </HotelPanelStatsContainer>
        )}
        <HotelPanelFeatures>
          <HotelPanelFeatureWrapper>
            <HotelPanelFeature onClick={() => { if (!checkInDatePayment) handleDropdownToggle('way') }}>
              <h3>Type</h3>
              <div className="panel-container">
                <span style={{ fontWeight: 400, color: '#9e9e9e' }}>
                  <span style={{ fontWeight: 700, color: '#5a5a5a' }}>{name}</span> (max {maxGuests}{' '}
                  guests)
                </span>
                <Triangle width={13} height={10} color="#1EB6FF" />
              </div>
            </HotelPanelFeature>
            {currentDropdown === 'way' && (
              <DropdownContainer
                name="way"
                noPadding
                handleCloseButtonClick={() => handleDropdownToggle('way')}
              >
                {products.map(option => (
                  <HotelPanelWays key={option.name} onClick={() => handleProductClick(option.name)}>
                    {option.name}
                  </HotelPanelWays>
                ))}
              </DropdownContainer>
            )}
          </HotelPanelFeatureWrapper>
          <HotelPanelFeatureWrapper>
            <HotelPanelFeature onClick={() => { if(!checkInDatePayment) this.handleDropdownToggle('date') }}>
              <h3>Check in</h3>
              <span className="panel-container">
                {moment(neededDate).format('MMM D YYYY')}
                <Calendar width={16} height={17} color="#1EB6FF" />
              </span>
            </HotelPanelFeature>
            {currentDropdown === 'date' && !isMobile && (
              <DropdownContainer
                name="date"
                handleCloseButtonClick={() => handleDropdownToggle('date')}
                onClickOutside={() => handleDropdownToggle('date')}
              >
                <DatePicker
                  handleDayClick={handleDayClick}
                  selectedDate={date}
                  calendarData={calendarData}
                  handleDateChange={handleDateChange}
                  productType={type}
                  needShowPasses
                />
                <DatePickerWaitlist>
                  <SignUpButton onClick={handleOpenSignUpButtonClick}>
                    <Bell />
                    Add me to waitlist
                  </SignUpButton>
                </DatePickerWaitlist>
              </DropdownContainer>
            ) || currentDropdown === 'date' &&
            (
              <SelectorModalMobile waitlistFeature displayShowButton={false} name="date" handleCloseButtonClick={() => handleDropdownToggle('date')} handleClearButtonClick={setDefaultDate} total={null} title={moment(neededDate).format('MMM DD YYYY')}>
                <DatePicker
                  monthsShown={12}
                  handleDayClick={handleDayClick}
                  selectedDate={date}
                  calendarData={calendarData}
                  handleDateChange={handleDateChange}
                  productType={type}
                  needShowPasses
                />
              </SelectorModalMobile>
            )}
          </HotelPanelFeatureWrapper>
          <HotelPanelFeatureWrapper>
            <HotelPanelFeature as="div" style={{ cursor: 'auto' }}>
              <h3>Guests</h3>
              <span className="panel-container">
                <AmountCounter
                  disabledInc={disabledInc || isComingSoon}
                  disabled={checkInDatePayment}
                  hiddenCounter
                  guestAmount={guests}
                  handleChange={handleGuestSelect}
                  setWarning={setWarning}
                  label={(
                    <Fragment>
                      {guests}{' '}
                      <span style={{ fontWeight: 400, color: '#9e9e9e' }}>
                        ({productAmount} {productTypeName.toLowerCase()})
                      </span>
                    </Fragment>
                  )}
                />
              </span>
            </HotelPanelFeature>
          </HotelPanelFeatureWrapper>
          {getWarningTag()}
        </HotelPanelFeatures>
        {(!checkInDatePayment &&
        userData &&
        !objectIsEmpty(userData.subscription) &&
        productAmountWithSubscription > 0 &&
        moment(userPreferences.date).isAfter(moment().add(1, 'day')) ||
        type !== 0 &&
        userData &&
        !objectIsEmpty(userData.subscription) ||
        productAmountWithSubscription > 0 &&
        !checkInDatePayment &&
        userData &&
        !objectIsEmpty(userData.subscription)) && <WhyCharged />}
        {!checkInDatePayment && (
          <HotelPanelTotalTable blurred={loadingPrice}>
            { userData && !objectIsEmpty(userData.subscription) && !userData.last24freeDayPass && type === 0 && moment(userPreferences.date).isBefore(moment().add(1, 'day')) ? (
              <Fragment>
                <li>
                  <div>${newPrice} x 1 day pass</div>
                  <div>$0.00</div>
                </li>
                {productAmount > 1 && (
                  <li>
                    <div>${oldTotal.toFixed(2)} x {productAmount - 1} {getProductTypeName(type, productAmount - 1).toLowerCase()}</div>
                    <div>${((productAmount - 1) * oldTotal).toFixed(2)}</div>
                  </li>
                )}
                {discountName && productAmount > 1 && (
                  <li style={{ color: '#11d17d' }}>
                    <div>{discountName}{`(${((total / oldTotal - 1) * 100).toFixed()}% OFF)`}</div>
                    <div>-${((productAmount - 1) * (oldTotal - total)).toFixed(2)}</div>
                  </li>
                )}
                {promo.status === 'success' && productAmount > 1 && (
                  <li style={{ color: '#11d17d' }}>
                    <div>{promo.info.discountName} {promo.info.type === 0 && (`(-${promo.info.amount}% OFF)`)}</div>
                    <div>-{getPromoValue(true)}</div>
                  </li>
                )}
                {rate !== 0 && productAmount > 1 && (
                  <li>
                    <div>Tax</div>
                    {promo.status === 'success' && !isErrored ? (
                      <div>${isErrored ? '0.00' : (calculateTotalWithPromo(true) * rate).toFixed(2)}</div>
                    ) : (
                      <div>${isErrored ? '0.00' : ((productAmount - 1) * tax).toFixed(2)}</div>
                    )}
                  </li>
                )}
                {productAmount > 1 && serviceFee > 0 && (
                  <li>
                    <div>Service Fee
                      <ServiceFeeToolTip
                        content="This helps us run our platform and offer services like 24/7 support on your trip"
                        placement="top"
                        fadeDuration={10}
                        padding={15}
                        radius={8}
                        fontSize='12px'
                        background="#ffffff"
                        color="#5a5a5a"
                        border="#ebebeb"
                      >
                        <QuestionTooltipBlock>?</QuestionTooltipBlock>
                      </ServiceFeeToolTip>
                    </div>
                    <div>
                      ${serviceFee.toFixed(2)}
                    </div>
                  </li>
                )}
                {!usingCredits && (
                  <li>
                    <div>Total</div>
                    <div>
                      {promo.status === 'success' && productAmount > 1 ? (
                        <span>${(calculateTotalWithPromo(true) * (1 + rate) + serviceFee).toFixed(2)}</span>
                      ) : (
                        <span>${total === 0 ? serviceFee : ((productAmount - 1) * total + (productAmount - 1) * tax + (productAmount > 1 ? serviceFee : 0)).toFixed(2)}</span>
                      )}
                    </div>
                  </li>
                )}
                {usingCredits && productAmount > 1 && (
                  <Fragment>
                    <li>
                      <div>Credit</div>
                      <div>
                        {promo.status === 'success' ? (
                          <p>-${(calculateTotalWithPromo(true) * (1 + rate)) === 0 ? '0.00' : userCredits >= (calculateTotalWithPromo(true) * (1 + rate) + (productAmount > 1 ? serviceFee : 0)) ? (calculateTotalWithPromo(true) * (1 + rate) + (productAmount > 1 ? serviceFee : 0)).toFixed(2) : userCredits.toFixed(2)}</p>
                        ) : (
                          <p>-${total === 0 ? '0.00' : userCredits >= ((productAmount - 1) * total + (productAmount - 1) * tax + (productAmount > 1 ? serviceFee : 0)).toFixed(2) ? ((productAmount - 1) * total + (productAmount - 1) * tax + (productAmount > 1 ? serviceFee : 0)).toFixed(2) : userCredits.toFixed(2)}</p>
                        )}
                      </div>
                    </li>
                    <li>
                      <div>Total</div>
                      <div>
                        {promo.status === 'success' ? (
                          <span>${(calculateTotalWithPromo(true) * (1 + rate) - userCredits + serviceFee) === 0 || (calculateTotalWithPromo(true) * (1 + rate) - userCredits + serviceFee) < 0 ? '0.00' : (calculateTotalWithPromo(true) * (1 + rate) - userCredits + serviceFee).toFixed(2)}</span>
                        ) : (
                          <span>${((productAmount - 1) * total + (productAmount - 1) * tax) === 0 || userCredits >= ((productAmount - 1) * total + (productAmount - 1) * tax + serviceFee) ? '0.00' : ((productAmount - 1) * total + (productAmount - 1) * tax - userCredits + serviceFee) < 0 ? '0.00' : ((productAmount - 1) * total + (productAmount - 1) * tax - userCredits + serviceFee).toFixed(2)}</span>
                        )}
                      </div>
                    </li>
                  </Fragment>
                )}
              </Fragment>
            ) : (
              <Fragment>
                <li>
                  <div>${oldTotal.toFixed(2)} x {productAmount} {productTypeName.toLowerCase()}</div>
                  <div>${(productAmount * oldTotal).toFixed(2)}</div>
                </li>
                {discountName && (
                  <li style={{ color: '#11d17d' }}>
                    <div>{discountName} {`(${((total/oldTotal - 1) * 100).toFixed()}% OFF)`}</div>
                    <div>-${(productAmount * (oldTotal - total)).toFixed(2)}</div>
                  </li>
                )}
                {promo.status === 'success' && (
                  <li style={{ color: '#11d17d' }}>
                    <div>{promo.info.discountName} {promo.info.type === 0 && (`(-${promo.info.amount}% OFF)`)}</div>
                    <div>-{getPromoValue()}</div>
                  </li>
                )}
                {rate !== 0 && (
                  <li>
                    <div>Tax</div>
                    {promo.status === 'success' ? (
                      <div>${isErrored ? '0.00' : (calculateTotalWithPromo() * rate).toFixed(2)}</div>
                    ) : (
                      <div>${isErrored ? '0.00' : (productAmount * tax).toFixed(2)}</div>
                    )}
                  </li>
                )}
                {serviceFee > 0 && (
                  <li>
                    <div>Service Fee
                      <ServiceFeeToolTip
                        content="This helps us run our platform and offer services like 24/7 support on your trip"
                        placement="top"
                        fadeDuration={10}
                        padding={15}
                        radius={8}
                        fontSize='12px'
                        background="#ffffff"
                        color="#5a5a5a"
                        border="#ebebeb"
                      >
                        <QuestionTooltipBlock>?</QuestionTooltipBlock>
                      </ServiceFeeToolTip>
                    </div>
                    <div>
                      ${serviceFee.toFixed(2)}
                    </div>
                  </li>
                )}
                {!usingCredits && (
                  <li>
                    <div>Total</div>
                    <div>
                      {promo.status === 'success' ? (
                        <span>${(calculateTotalWithPromo() * (1 + rate) + serviceFee).toFixed(2)}</span>
                      ) : (
                        <span>${total === 0 ? serviceFee.toFixed(2) : (productAmount * total + productAmount * tax + serviceFee).toFixed(2)}</span>
                      )}
                    </div>
                  </li>
                )}
                {usingCredits && userCredits &&(
                  <Fragment>
                    <li>
                      <div>Credit</div>
                      <div>
                        {promo.status === 'success' ? (
                          <p>-${(calculateTotalWithPromo() * (1 + rate)) === 0 ? serviceFee : userCredits >= (calculateTotalWithPromo() * (1 + rate)) + serviceFee ? (calculateTotalWithPromo() * (1 + rate) + serviceFee).toFixed(2) : userCredits.toFixed(2)}</p>
                        ) : (
                          <p>-${(productAmount * total + productAmount * tax) === 0 ? serviceFee : userCredits >= (productAmount * total + productAmount * tax + serviceFee) ? (productAmount * total + productAmount * tax + serviceFee).toFixed(2) : userCredits.toFixed(2)}</p>
                        )}
                      </div>
                    </li>
                    <li>
                      <div>Total</div>
                      <div>
                        {promo.status === 'success' ? (
                          <span>${(calculateTotalWithPromo() * (1 + rate)) === 0 || userCredits > (calculateTotalWithPromo() * (1 + rate) + serviceFee) ? '0.00' : (calculateTotalWithPromo() * (1 + rate) - userCredits + serviceFee).toFixed(2)}</span>
                        ) : (
                          <span>${(productAmount * total + productAmount * tax) === 0 || userCredits >= (productAmount * total + productAmount * tax + serviceFee) ? '0.00' : (productAmount * total + productAmount * tax - userCredits + serviceFee) < 0 ? '0.00' : (productAmount * total + productAmount * tax - userCredits + serviceFee).toFixed(2)}</span>
                        )}
                      </div>
                    </li>
                  </Fragment>
                )}
              </Fragment>
            )}
          </HotelPanelTotalTable>
        )}
        {checkInDatePayment && (
          <HotelPanelTotalTable blurred={loadingPrice}>
            <li>
              <div>Additional payment</div>
              <div>${diff.toFixed(2)}</div>
            </li>
            {changingTax > 0 && (
              <li>
                <div>Tax</div>
                <div>${changingTax.toFixed(2)}</div>
              </li>
            )}
            <li>
              <div>Total</div>
              <div>${(changingTax+diff).toFixed(2)}</div>
            </li>
            {usingCredits && (
              <Fragment>
                <li>
                  <div>Credit</div>
                  <div>
                      -${userCredits >= (changingTax+diff).toFixed(2)  ? (changingTax+diff).toFixed(2) : userCredits.toFixed(2)}
                  </div>
                </li>
                <li>
                  <div>Order Total</div>
                  <div>
                    ${(changingTax+diff).toFixed(2) > userCredits ? ((changingTax+diff).toFixed(2)-userCredits).toFixed(2) : '0.00'}
                  </div>
                </li>
              </Fragment>
            )}
          </HotelPanelTotalTable>
        )}
        {checkoutPage &&  (
          <Fragment>
            {!checkInDatePayment && (
              <PromoBox disabled={checkInDatePayment} />
            )}
            <HotelPanelFooter>
              <Shield />
              <HotelPanelDescription>
                Cancel within {process.env.CANCELING_HOURS} hours of booking to get a full refund.
              </HotelPanelDescription>
            </HotelPanelFooter>
          </Fragment>
        )}
        {!checkoutPage && (
          <Fragment>
            <HotelPanelBook>
              <Button
                htmlType="button"
                theme="primary"
                disabled={isPreview
                  ? false
                  : (isComingSoon || disabledBtn || loading || isErrored)}
                onClick={isPreview ? (() => {
                  // Marketing previews land on /preview/:token. Send the
                  // hotel rep to the portal invite URL so they can claim
                  // the listing and continue through onboarding to sign.
                  const m = typeof window !== 'undefined'
                    && window.location.pathname.match(/\/preview\/([^/?#]+)/);
                  const token = m && m[1];
                  const portalBase = process.env.PORTAL_URL || 'http://localhost:3005';
                  if (token) window.location.href = `${portalBase}/invite/${token}`;
                }) : handleBookClick}
              >
                {isPreview ? 'Claim & Register' : (loading && membershipError === '' ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="loader"
                    preserveAspectRatio="xMidYMid"
                    style={{ width: '115px', height: '20px' }}
                    viewBox="0 0 68 14"
                  >
                    <g transform="translate(7 7)">
                      <circle r="7" fill="#ffffff" transform="scale(0.8984)">
                        <animateTransform
                          attributeName="transform"
                          begin="-0.375s"
                          calcMode="spline"
                          dur="1s"
                          keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                          keyTimes="0;0.5;1"
                          repeatCount="indefinite"
                          type="scale"
                          values="0;1;0"
                        />
                      </circle>
                    </g>
                    <g transform="translate(27 7)">
                      <circle r="7" fill="#ffffff" transform="scale(0.59269)">
                        <animateTransform
                          attributeName="transform"
                          begin="-0.25s"
                          calcMode="spline"
                          dur="1s"
                          keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                          keyTimes="0;0.5;1"
                          repeatCount="indefinite"
                          type="scale"
                          values="0;1;0"
                        />
                      </circle>
                    </g>
                    <g transform="translate(47 7)">
                      <circle r="7" fill="#ffffff" transform="scale(0.2416)">
                        <animateTransform
                          attributeName="transform"
                          begin="-0.125s"
                          calcMode="spline"
                          dur="1s"
                          keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                          keyTimes="0;0.5;1"
                          repeatCount="indefinite"
                          type="scale"
                          values="0;1;0"
                        />
                      </circle>
                    </g>
                    <g transform="translate(67 7)">
                      <circle r="7" fill="#ffffff" transform="scale(0.01308)">
                        <animateTransform
                          attributeName="transform"
                          begin="0s"
                          calcMode="spline"
                          dur="1s"
                          keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                          keyTimes="0;0.5;1"
                          repeatCount="indefinite"
                          type="scale"
                          values="0;1;0"
                        />
                      </circle>
                    </g>
                  </svg>
                ) : 'Book Now')}
              </Button>
              { membershipError !== '' && (
                <p style={{color:'red'}}>{membershipError}</p>
              )
              }
              {!isPreview && <HotelPanelNote>You won&apos;t be charged yet</HotelPanelNote>}
              {isPreview && (
                <HotelPanelNote style={{ color: '#666' }}>
                  This is how guests will see your listing. Claim to customize it.
                </HotelPanelNote>
              )}
            </HotelPanelBook>
            {isTablet && (
              <HotelPanelFooter>
                <Gold />
                <HotelPanelDescription>
                  {counter} people are looking at this pass right now.
                </HotelPanelDescription>
              </HotelPanelFooter>
            )}
          </Fragment>
        )}
      </HotelPanelArticle>
    );
  }
}

export default HotelPanel;
